(function () {
  'use strict';

  var CSS_COLORS = {
    // White / off-white
    'weiß': '#ffffff', 'weiss': '#ffffff', 'white': '#ffffff',
    'off white': '#f5f0e0', 'offwhite': '#f5f0e0', 'off-white': '#f5f0e0',
    'creme': '#f5f0e0', 'cream': '#f5f0e0',
    'ivory': '#fffff0', 'elfenbein': '#fffff0',
    'natur': '#f0e8d0', 'natural': '#f0e8d0',
    'snow': '#fffafa', 'wollweiß': '#fffaf0', 'wollweiss': '#fffaf0',
    // Black
    'schwarz': '#111111', 'black': '#111111',
    // Dark grey / charcoal
    'anthrazit': '#3c3c3c', 'anthracite': '#3c3c3c',
    'charcoal': '#383838', 'dunkelgrau': '#404040', 'dark grey': '#404040', 'dark gray': '#404040',
    'graphit': '#3e3e3e', 'graphite': '#3e3e3e',
    'slate': '#6a737d', 'schiefer': '#6a737d',
    // Mid grey
    'grau': '#8a8a8a', 'grey': '#8a8a8a', 'gray': '#8a8a8a',
    'mittelgrau': '#8a8a8a', 'medium grey': '#8a8a8a', 'medium gray': '#8a8a8a',
    'heather grey': '#9a9a9a', 'heather gray': '#9a9a9a', 'heathergrau': '#9a9a9a',
    'heather': '#9a9a9a',
    'ash': '#b2b2b2', 'asche': '#b2b2b2', 'ash grey': '#b2b2b2', 'ash gray': '#b2b2b2',
    'stone': '#a8a09c', 'stein': '#a8a09c', 'stone grey': '#a8a09c', 'stone gray': '#a8a09c',
    'pebble': '#a0998f',
    // Light grey
    'hellgrau': '#c8c8c8', 'light grey': '#c8c8c8', 'light gray': '#c8c8c8',
    'silber': '#b0b0b0', 'silver': '#b0b0b0',
    'mist': '#d4d4d4',
    // Red
    'rot': '#dc1c1c', 'red': '#dc1c1c',
    'dunkelrot': '#8b0000', 'dark red': '#8b0000',
    'bordeaux': '#6e1022', 'burgund': '#6e1022', 'burgundy': '#6e1022', 'weinrot': '#6e1022',
    'maroon': '#800000',
    'koralle': '#e06050', 'coral': '#e06050',
    'lachs': '#f4a67a', 'salmon': '#f4a67a',
    'himbeere': '#c82060', 'raspberry': '#c82060',
    // Blue
    'blau': '#1a4db3', 'blue': '#1a4db3',
    'marineblau': '#1a3464', 'marine': '#1a3464', 'navy': '#1a3464',
    'navy blue': '#1a3464', 'dunkelblau': '#1a3464',
    'french navy': '#0B1F3A',
    'royalblau': '#2855b8', 'royal blue': '#2855b8',
    'hellblau': '#6baed6', 'sky blue': '#6baed6', 'babyblau': '#9ecae1', 'baby blue': '#9ecae1',
    'eisblau': '#b0d4f0', 'ice blue': '#b0d4f0',
    'petrol': '#005f6b',
    'türkis': '#009b9b', 'tuerkis': '#009b9b', 'teal': '#008080', 'türkisblau': '#009b9b',
    'kobalt': '#0047ab', 'cobalt': '#0047ab', 'cobalt blue': '#0047ab',
    'indigo': '#4b0082',
    'denim': '#1560bd',
    // Green
    'grün': '#1c7c2e', 'gruen': '#1c7c2e', 'green': '#1c7c2e',
    'dunkelgrün': '#145222', 'dunkelgruen': '#145222', 'dark green': '#145222', 'forest': '#228b22',
    'forest green': '#228b22', 'waldgrün': '#228b22',
    'mint': '#a0d9b0', 'mintgrün': '#a0d9b0', 'mintgruen': '#a0d9b0',
    'khaki': '#8b8044', 'oliv': '#737321', 'olive': '#737321',
    'military': '#4b5320', 'military green': '#4b5320',
    'sage': '#87ae73', 'salbei': '#87ae73',
    'moosgrün': '#3d6b3e', 'moss': '#8a9a5b', 'moss green': '#8a9a5b',
    // Yellow / Orange
    'gelb': '#f5d300', 'yellow': '#f5d300',
    'senf': '#c29a00', 'mustard': '#c29a00', 'senfgelb': '#c29a00',
    'orange': '#f07800',
    'gold': '#d4a820',
    'apricot': '#fbceb1', 'pfirsich': '#ffcba4', 'peach': '#ffcba4',
    // Purple / Pink
    'lila': '#7b3fa0', 'purple': '#7b3fa0', 'violett': '#7b3fa0', 'violet': '#7b3fa0',
    'flieder': '#c3a0d8', 'lilac': '#c3a0d8', 'lavender': '#b57edc', 'lavendel': '#b57edc',
    'plum': '#8e4585', 'pflaume': '#8e4585',
    'pink': '#e8447a', 'hot pink': '#ff69b4',
    'rosa': '#f29bb0', 'rose': '#f29bb0', 'hellrosa': '#ffb6c1', 'light pink': '#ffb6c1',
    'mauve': '#c4769a',
    // Brown / Beige / Earth
    'braun': '#7c4a1a', 'brown': '#7c4a1a',
    'dunkelbraun': '#4a2800', 'dark brown': '#4a2800',
    'hellbraun': '#c8845a', 'light brown': '#c8845a', 'camel': '#c19a6b',
    'beige': '#d4b896', 'sand': '#c8b090',
    'caramel': '#c68642', 'karamell': '#c68642',
    'tan': '#d2b48c', 'taupe': '#8b7355',
    'mokka': '#7b5a3a', 'mocha': '#7b5a3a',
    'cognac': '#9a4722',
  };

  function colorFromName(name) {
    if (!name) return null;
    return CSS_COLORS[name.toLowerCase().trim().replace(/[-_]+/g, ' ')] || null;
  }

  // Apply a solid CSS color to a swatch element via CSS custom property.
  // Skip if already set inline (Shopify native swatch data or prior JS call).
  // Also adds is-white-swatch class when the resolved color is pure white.
  function applyColor(el, colorName) {
    if (el.style.getPropertyValue('--cs-bg') || el.style.getPropertyValue('--cs-color')) return;
    var css = colorFromName(colorName);
    if (css) {
      el.style.setProperty('--cs-bg', css);
      el.style.setProperty('--cs-color', css);
      if (css === '#ffffff') {
        el.classList.add('is-white-swatch');
      }
    }
  }

  // ─── Collection card: swatch click handling (event delegation) ─

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-swatch');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation(); // prevent card link from firing on mobile tap

    var swatches = btn.closest('.card-swatches');
    var cardWrapper = btn.closest('.card-wrapper');
    if (!swatches || !cardWrapper) return;

    // Update selected state across all swatches in this card
    swatches.querySelectorAll('.card-swatch').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    // Update every product image inside the card
    var newSrc = btn.dataset.img;
    var newSrcset = btn.dataset.srcset;
    if (newSrc) {
      cardWrapper.querySelectorAll('.card__inner .card__media img').forEach(function (img) {
        if (newSrcset) img.srcset = newSrcset;
        img.src = newSrc;
      });
    }

    // Update card link(s) to the variant URL
    var newUrl = btn.dataset.url;
    if (newUrl) {
      cardWrapper.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]').forEach(function (a) {
        a.href = newUrl;
      });
    }
  });

  // ─── Product page: position-based image switching ────────────
  //
  // Each product is configured so that color option position N maps to
  // product image N (image-only media, filtered with `where: 'media_type', 'image'`).
  // Dawn's product-info.js calls setActiveMedia(variant.featured_media) via AJAX.
  // We subscribe to PUB_SUB_EVENTS.variantChange which fires AFTER that call, so
  // our setActiveMedia wins and corrects the gallery to the positional image.
  //
  // colorMetaMap: sectionId → { imageIds: [], colorIndex: <number|null> }

  var colorMetaMap = {};
  var variantChangeSubscribed = false;

  function applyColorImageForSection(sectionId) {
    var state = colorMetaMap[sectionId];
    if (!state || state.colorIndex == null) return;
    var imageId = state.imageIds[state.colorIndex];
    if (!imageId) return;
    var gallery = document.getElementById('MediaGallery-' + sectionId)
               || document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(sectionId + '-' + imageId, true);
    }
  }

  function setupProductColorImageSwitch(root) {
    (root || document).querySelectorAll('.abs-color-meta').forEach(function (meta) {
      var variantSelects = meta.closest('variant-selects');
      if (!variantSelects) return;

      // Guard against duplicate setup on the same element
      if (variantSelects._absImgSetup) return;
      variantSelects._absImgSetup = true;

      var sectionId = meta.dataset.section;
      var imageIds = (meta.dataset.imageIds || '').split(',').filter(Boolean);
      if (!imageIds.length) return;

      colorMetaMap[sectionId] = { imageIds: imageIds, colorIndex: null };

      // Color radios in DOM order = Shopify's exact configured color-option order
      var colorRadios = variantSelects.querySelectorAll(
        '.product-form__input--color-circles input[type="radio"]'
      );
      if (!colorRadios.length) return;

      // Seed the index from whichever radio is pre-checked by Shopify
      colorRadios.forEach(function (radio, idx) {
        if (radio.checked) colorMetaMap[sectionId].colorIndex = idx;
      });

      // Track selection changes; the PUB_SUB subscriber will apply the image
      colorRadios.forEach(function (radio, idx) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          colorMetaMap[sectionId].colorIndex = idx;
        });
      });
    });
  }

  // Subscribe once to Dawn's post-variant-update event.
  // PUB_SUB_EVENTS.variantChange fires after product-info.js calls setActiveMedia,
  // so our override runs last and sets the gallery to the positional color image.
  function subscribeToVariantChange() {
    if (variantChangeSubscribed) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    variantChangeSubscribed = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event && event.data && event.data.sectionId;
      if (sectionId) applyColorImageForSection(sectionId);
    });
  }

  // ─── Apply colors from name map to product page color labels ──

  function applyProductColors(root) {
    (root || document).querySelectorAll('.product-form__input--color-circles label[data-color-name]').forEach(function (label) {
      applyColor(label, label.dataset.colorName);
    });
  }

  // ─── Init: apply all colors on page load ─────────────────────

  // ─── Product page: apply color_index from URL on initial navigation ──
  // Called in init() after setupProductColorImageSwitch() has seeded colorMetaMap.
  // media-gallery.js loads AFTER abs-swatches.js in main-product.liquid, so
  // setActiveMedia is not yet callable at init time — use whenDefined() to wait.
  function applyUrlColorIndex() {
    if (typeof URLSearchParams === 'undefined') return;
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('color_index');
    if (raw === null) return;
    var idx = parseInt(raw, 10);
    if (isNaN(idx) || idx < 0) return;
    customElements.whenDefined('media-gallery').then(function () {
      Object.keys(colorMetaMap).forEach(function (sectionId) {
        colorMetaMap[sectionId].colorIndex = idx;
        applyColorImageForSection(sectionId);
      });
    });
  }

  function initCardSwatches(root) {
    (root || document).querySelectorAll('.card-swatch').forEach(function (btn) {
      applyColor(btn, btn.dataset.colorName);
    });
  }

  function init() {
    // Collection card swatches
    initCardSwatches();

    // Product page color circles
    applyProductColors();

    // Product page: position-based image switching
    setupProductColorImageSwitch();
    subscribeToVariantChange();

    // Apply color position from collection→product URL parameter
    applyUrlColorIndex();

    // Watch product-recommendations elements for swatches injected after page load.
    // The product-recommendations web component fetches cards via AJAX (IntersectionObserver
    // fires when the section scrolls into view), so init() runs before the HTML exists.
    // When innerHTML is set by the fetch, this observer fires and applies swatch colors.
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      if (el._absSwatchObserving) return;
      el._absSwatchObserving = true;
      new MutationObserver(function () {
        initCardSwatches(el);
      }).observe(el, { childList: true });
    });

    // Watch for Dawn's viewTransition inserting fresh variant-selects elements.
    // When a variant changes, Dawn replaces variant-selects via HTMLUpdateUtility.viewTransition
    // which inserts a brand-new element that won't have JS-set custom properties.
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      var parent = vs.parentNode;
      if (!parent || parent._absColorObserving) return;
      parent._absColorObserving = true;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mut) {
          mut.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.tagName.toUpperCase() === 'VARIANT-SELECTS') {
              applyProductColors(node);
              setupProductColorImageSwitch(node);
            }
          });
        });
      }).observe(parent, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: re-init on section load
  document.addEventListener('shopify:section:load', init);

})();
